import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { Chip, Grid } from "@mui/material";


interface CouponsHandlerProps {}

const CouponsHandler: FC<CouponsHandlerProps> = () => {
  const { t } = useTranslation();  
  const {watch, setValue} = useFormContext(); 
  
  const watchedPromoCode = watch("promotionalCode") as string[];

  const handleClick = (idxDelete: number) => {
    const promocodes = watchedPromoCode.filter((p, idx) => idx !== idxDelete);
    setValue("promotionalCode", promocodes);
  }

  return <>
    <Grid container gap={1} alignItems="center">
      <Grid item>
        {!!watchedPromoCode.length && t("common:text.contractation_promotional_applied")}
      </Grid>
      {watchedPromoCode.map((promocode, idx) => <Grid item key={idx}>
          <Chip 
            label={promocode} 
            variant="outlined" 
            onDelete={() => handleClick(idx)} 
          />
      </Grid>)}
    </Grid>
  </>
}

export default CouponsHandler;